import {Injectable} from '@angular/core';
import {IMetadataGroup} from "../interfaces";
import {MetadataService} from "../../../../app.services/clinical/metadata/services/metadata.service";
import * as _ from "lodash";
import {IMetadata} from "../interfaces/metadata/imetadata";

const CREATED_BY_BUILDER = 'createdByBuilder';
@Injectable({ providedIn: 'root' })
  export class ModelBuilder {
	constructor(private meta: MetadataService) {
	}

	build(metadataGroup: IMetadataGroup, leafModelItems?: any): any {
		let model = {};
		model[CREATED_BY_BUILDER] = 1; // flag fo further use

		for (let field in metadataGroup) {
			if (metadataGroup.hasOwnProperty(field)) {
				let fieldMetadata = metadataGroup[field];

				if (fieldMetadata.calculated) {
					continue;
				}

				if (fieldMetadata.type === 'group') {
					if (fieldMetadata.multiple && !this.isBuildRequired(fieldMetadata)) {
						model[field] = [];
					} else {
						let subModel;
						if (leafModelItems && leafModelItems[field] === null) {
							continue;
						} else if (leafModelItems && _.isObject(leafModelItems[field])) {
							subModel = this.build(fieldMetadata.fields, leafModelItems[field]);
						} else {
							subModel = this.build(fieldMetadata.fields);
						}
						model[field] = fieldMetadata.multiple ? [subModel] : subModel;
					}
					continue;
				}

				if (fieldMetadata.type === 'lookup') {
					model['FKLookupRows'] = model['FKLookupRows'] || {};

					if (fieldMetadata.defaultValue) {
						model['FKLookupRows'][field] = fieldMetadata.defaultValue;
						model[field] = fieldMetadata.defaultValue[fieldMetadata.lookupKey];
					} else {
						model['FKLookupRows'][field] = {};
						model[field] = null;
					}

					continue;
				}

				model[field] = fieldMetadata.defaultValue || null;
			}
		}

		return model;
	}

	setIds(metadataGroup: IMetadataGroup, model: any, siteProtMode?: boolean, fieldName?: string,overrideExistingIds?:boolean) {
		if (model && !_.isEmpty(model)) {
			let keys = Object.keys(model);
			for (let i = 0; i < keys.length; i++) {
				if (_.isObject(model[keys[i]]) && this.modelIsEmpty(model[keys[i]], metadataGroup[keys[i]])) {
					model[keys[i]] = null;
				}
			}

			if (siteProtMode) {
				// we have a workaround here we need to address - the client currently creates empty site-protocol
				// objects as part of the model.
				// if we created the order from scratch using the web client i believe the build function would have
				// created these protocol entries as part of the model, but if the clinical object was created
				// from the c# client we have an empty object with no keys and i dont want to send it to the server
				// for now.
				if (Object.keys(model).length) {
					if (this.isDirectChild(this.meta.patient, metadataGroup, fieldName)) {
						this.setSitePortFkId(metadataGroup, model, "patientPersonKey",overrideExistingIds,fieldName);
					} else if (this.isDirectChild(this.meta.order, metadataGroup, fieldName)) {
						this.setSitePortFkId(metadataGroup, model, "orderKey",overrideExistingIds,fieldName);
					} else if (this.isDirectChild(this.meta.sps, metadataGroup, fieldName)) {
						// for the column which is not used we need to set an indication not to include it in the
						// server automatic ids setting
						this.setSitePortFkId(metadataGroup, model, "spsId",overrideExistingIds,fieldName);
						model["ppsKey"] = '$$$NULL$$$';
					} else if (this.isDirectChild(this.meta.pps, metadataGroup, fieldName)) {
						this.setSitePortFkId(metadataGroup, model, "ppsKey",overrideExistingIds,fieldName);
						model["spsId"] = '$$$NULL$$$';
					}

					// how to handle sps/pps?
				}
				// the ID for site protocols is sent as nulls and determined on the server
			} else {
				for (let field in metadataGroup) {
					if (metadataGroup.hasOwnProperty(field)) {
						if (metadataGroup[field].id && (overrideExistingIds || !model[field])) {
							model[field] = -_.uniqueId();
						}
						if (metadataGroup[field].type === 'group' && metadataGroup[field].multiple &&
							model[field] && _.isArray(model[field])) {
							model[field].forEach(m => this.setIds(metadataGroup[field].fields, m, field.startsWith("siteProt"), field,overrideExistingIds));
						}
					}
				}
			}
		}
	}

	public isDirectChild(parent: IMetadataGroup, child: IMetadataGroup, childName: string): boolean {
		return parent[childName] && parent[childName].fields === child;
	}

	public setSitePortFkId(metadataGroup: IMetadataGroup, model: any, idProp: string,overrideExistingIds?:boolean,protTableName?:string) {
		// how to handle sps/pps??
		// notice we're setting a new pk id here, but it will actually be overriden by the server.
		if (metadataGroup[idProp] && (overrideExistingIds||!(model[idProp]))) {
			model[idProp] = -_.uniqueId();
		}
		if (overrideExistingIds && protTableName){
			let nameOfProtocolKeyCol = protTableName+"Key";
			model[nameOfProtocolKeyCol]=null;
		}
	}

	public modelIsEmpty(model: any, metadata?: IMetadata): boolean {
		let keys = Object.keys(model);
		if (keys.length > 0) {
			if (_.isArray(model)) {
				let cleanModel = [];
				for (let i = model.length - 1; i >= 0; i--) {
					if (!this.modelIsEmpty(model[i], metadata)) {
						cleanModel.push(model[i]);
					} else {
						model.splice(i, 1);
					}
				}
				//model = model.length !== cleanModel.length ? cleanModel : model;
				return cleanModel.length === 0 ? true : false;
			} else if (model[CREATED_BY_BUILDER]) {
				for (let i = 0; i < keys.length; i++) {
					let emptyValue = (metadata && metadata.fields[keys[i]]) ?
						(metadata.fields[keys[i]].defaultValue || null) : null;

					if (!_.isArray(model[keys[i]]) && (keys[i] !== 'FKLookupRows'
							&& keys[i] !== CREATED_BY_BUILDER && model[keys[i]] !== emptyValue) ||
						(_.isArray(model[keys[i]]) && !this.modelIsEmpty(model[keys[i]],
							metadata ? metadata.fields[keys[i]] : null))) {
						return false;
					}
				}
				return true;
			}
			return false;
		} else if (_.isDate(model)) {
			return false;
		}else if (model instanceof Blob){
			return false;
		}
		return true;
	}

	// generate full objects with defaults and properties for our basic clinical entities.
	// these levels of the patient will be created automatically when higher levels are requested.
	// more specific levels will be created on specific object level - not as general arrays
	public isBuildRequired(metadataGroup: IMetadata) {
		return (this.isDirectChild(this.meta.patient, metadataGroup.fields, "visit")) ||
			(this.isDirectChild(this.meta.visit, metadataGroup.fields, "orders")) ||
			(this.isDirectChild(this.meta.order, metadataGroup.fields, "requestedProcedure")) ||
			(this.isDirectChild(this.meta.requestedProcedure, metadataGroup.fields, "sps"));
	}
}
